import PropTypes from "prop-types";
import { useState } from "react";
import TextInput from "@shared/v2/TextInput";
import FieldLabel from "@shared/v2/FieldLabel";
import TextButton from "@shared/v2/TextButton";
import Button from "@shared/v2/Button";
import { CircleInfoSolidV6, PencilSolidV6 } from "@shared/v2/Icomoon";
import CollapsibleWebsiteCard from "../shared/CollapsibleWebsiteCard";
import SeoHelpModal from "../shared/SeoHelpModal";
import EditingSlugsModal from "../shared/EditingSlugsModal";

const SeoPanel = ({ data = undefined, setSeoData }) => {
  const [seoModalIsOpen, setSeoModalIsOpen] = useState(false);
  const [editSlugModalIsOpen, setEditSlugModalIsOpen] = useState(false);

  return (
    <>
      <CollapsibleWebsiteCard
        title="SEO"
        action={
          <Button schema="tertiary" onClick={() => setSeoModalIsOpen(true)}>
            <CircleInfoSolidV6 size="s" /> Help
          </Button>
        }
      >
        <div className="tw-flex tw-flex-col tw-gap-[24px]">
          <div className="tw-flex tw-flex-col tw-items-start tw-gap-[4px]">
            <FieldLabel label="Slug" />
            <div>{data?.slug}</div>
            <TextButton className="tw-ml-[-6px]" onClick={() => setEditSlugModalIsOpen(true)}>
              Edit <PencilSolidV6 size="s" />
            </TextButton>
          </div>
          <TextInput
            autoComplete="off"
            label="Meta Title"
            placeholder="Set your browser tab text"
            value={data?.seoTitle}
            onChange={(e) =>
              setSeoData({
                ...data,
                seoTitle: e.target.value,
              })
            }
          />
          <TextInput
            label="Meta Description"
            placeholder="Brief summary of your webpage that appears in search results"
            multiline
            rows={5}
            value={data?.seoDescription}
            onChange={(e) =>
              setSeoData({
                ...data,
                seoDescription: e.target.value,
              })
            }
          />
        </div>
      </CollapsibleWebsiteCard>
      <SeoHelpModal open={seoModalIsOpen} onClose={() => setSeoModalIsOpen(false)} />
      <EditingSlugsModal open={editSlugModalIsOpen} onClose={() => setEditSlugModalIsOpen(false)} />
    </>
  );
};

SeoPanel.propTypes = {
  data: PropTypes.shape({
    slug: PropTypes.string,
    seoTitle: PropTypes.string,
    seoDescription: PropTypes.string,
  }),
  setSeoData: PropTypes.func.isRequired,
};

export default SeoPanel;
